import { Component, OnInit } from '@angular/core';
import {AppBreadcrumbService} from '../app.breadcrumb.service';

@Component({
  selector: 'afm-help',
  template: `<h2>HOME</h2>
            <div class="p-grid p-fluid card">
            <afm-input label="ok" class="p-m-5"></afm-input>
            <afm-input label="ok" class="p-m-5"></afm-input>
            <afm-input label="ok" class="p-m-5"></afm-input>
            <afm-input label="ok" class="p-m-5"></afm-input>
            </div>`,
  styleUrls: ['./dashboard.component.css']
})
export class DashBoardComponent implements OnInit {

  constructor(public breadcrumbService: AppBreadcrumbService) { }

  ngOnInit() {
        this.breadcrumbService.setItems([
            { label: 'DashBoard' }
        ]);
  }

}
